<span class="pass" [ngClass]="{'pass-active': active === undefined? false: active}">
  <span class="fakeValue" *ngIf="containsValue() || active">•</span>
  <span class="fakeValue star" *ngIf="!containsValue()">*</span>
  <input #pin type="password" size="1" style="text-align:center;" maxlength="1" (input)="onInput($event.target)">
</span>
